<script>
  export let message;
  export let close = () => {
    message = null;
  };
  export let confirm = null;
  export let confirmText = "";
  export let confirmDanger = false;
  export let cancel = null;
  export let cancelText = "";
  export let needsAuth = false;

  let waitingForAction = false;
  let clickable = false;
  let clickTimer;

  $: if (message) {
    clickable = false;
    clearTimeout(clickTimer);
    clickTimer = setTimeout(() => { clickable = true; }, 300);
  }

  function handleBgClick() {
    if (clickable) {
      message = null;
      close();
    }
  }
</script>

<svelte:window on:keydown={(e) => { if (e.key === 'Escape' && clickable) { message = null; close(); } }} />

{#if message}
  <div class="bg" on:click={handleBgClick}>
    <div class="window" on:click|stopPropagation>
      <div class="popup-message">
        {@html message}
      </div>

      <button
        on:keydown={() => {
          message = null;
          close();
        }}
        on:click={() => {
          message = null;
          close();
        }}
        class="btn btn-danger btn-outline close"
      >
        <svg class="icon">
          <use href="/icons.svg#clear" />
        </svg>
      </button>

      <div class="popup-actions">
        {#if confirm}
          <button
            class="btn"
            class:btn-danger={confirmDanger}
            class:btn-outline={!confirmDanger}
            disabled={waitingForAction}
            on:click|stopPropagation={() => {
              waitingForAction = true;
              confirm();
            }}
          >
            {confirmText}
          </button>
        {/if}
        {#if cancel}
          <button
            class="btn btn-outline"
            on:keydown={cancel}
            on:click|stopPropagation={cancel}
          >
            {cancelText}
          </button>
        {/if}
      </div>
      {#if needsAuth === true}
        <div>
          <button
            class="btn btn-outline"
            on:click|stopPropagation={() => (window.location = "/login")}
          >
            Sign In
          </button>
          <button
            class="btn btn-outline"
            on:click|stopPropagation={() => (window.location = "/register")}
          >
            Register
          </button>
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  .bg {
    position: fixed;
    z-index: 1000;
    display: flex;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
  }

  .window {
    position: relative;
    box-sizing: border-box;
    width: 480px;
    max-width: calc(100% - var(--spacing));
    max-height: 90vh;
    overflow-y: auto;
    margin: var(--spacing) auto;
    padding: var(--spacing);
    padding-top: calc(var(--spacing) * 1.5);
    padding-right: calc(var(--spacing) * 2);
    border-radius: var(--border-radius);
    background: var(--col-gray-100);
    border: solid 1px var(--col-gray-90);
    box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  }

  .popup-message {
    margin-bottom: var(--spacing);
    line-height: 1.6;
  }

  .popup-message :global(h3) {
    margin-bottom: var(--spacing-sm);
    font-size: var(--font-size-lg);
  }

  .popup-message :global(p) {
    margin-bottom: var(--spacing-sm);
    color: var(--col-gray-30);
  }

  .popup-message :global(p:last-child) {
    margin-bottom: 0;
  }

  .popup-message :global(ul) {
    padding-left: var(--spacing);
    margin-bottom: var(--spacing-sm);
    color: var(--col-gray-30);
  }

  .popup-message :global(li) {
    margin-bottom: var(--spacing-xs);
  }

  .close {
    background: var(--col-gray-100);
    position: absolute;
    z-index: 1000;
    top: var(--spacing-xs);
    right: var(--spacing-xs);
    padding: var(--spacing-xs);
  }

  .popup-actions button {
    width: 175px;
  }

  @media (max-width: 900px) {
    .popup-actions {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: center;
    }

    .popup-actions button {
      margin: 0px !important;
    }
  }
</style>
